import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import i18next from 'i18n/i18n';
import { DEVICE_MODAL_TYPE, YN_TYPE } from 'types/enumType';

export const deviceInfoSchema = yupResolver(
  yup.object({
    id: yup.number().defined(),
    name: yup.string().trim().required(i18next.t('validation.enterZone')),
    type: yup.mixed<DEVICE_MODAL_TYPE>().defined(),
    manage: yup.mixed<YN_TYPE>().optional(),
    activate: yup.mixed<YN_TYPE>().optional(),
  }),
);

export const equipmentInfoSchema = yupResolver(
  yup.object({
    id: yup.number().defined(),
    code: yup.string().defined(),
    itemCode: yup.string().required(i18next.t('validation.enterCode')),
    eqCd: yup.string().max(10, i18next.t('validation.codeCount')).defined(),
    mdmCode: yup.string().defined(),
    name: yup.string().trim().required(i18next.t('validation.enterDevice')),
    type: yup.mixed<DEVICE_MODAL_TYPE>().defined(),
    deptId: yup
      .number()
      .typeError(i18next.t('validation.enterDept'))
      .required(i18next.t('validation.enterDept')),
    activate: yup.mixed<YN_TYPE>().optional(),
  }),
);

export const planImageSchema = yupResolver(yup.object({
  typeId: yup.number().defined(),
  type: yup.mixed<DEVICE_MODAL_TYPE>().defined(),
  image: yup.mixed<FileList>().required(i18next.t('validation.imageRegist'))
    .test("file", i18next.t('validation.imageRegist'), (value: FileList) => !!value?.length)
    .test("fileSize", i18next.t('validation.oversize'), (value: FileList) => {
      if (!value?.length) {
        return false;
      }
      return value[0].size <= 10000000
    })
}))
